import React, { useEffect, useState } from "react";
import "./Categories.scss";
import BarChart from "../Charts/BarChart/BarChart";
import { useSelector } from "react-redux";

const colors = ["#C1E6F6", "#DCF2FB", "#115774", "#65C1E8", "#092B3A"];

const CategoryAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);
  const { categoriesAnalytics: categoriesAnalyticsData } = useSelector(
    (state) => state.analyticsReducer
  );

  const [totalData, setTotalData] = useState({
    total_amount: 0.0,
    total_quantity: 0,
    total_return_quantity: 0,
  });

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: colors,
        borderWidth: 0,
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    let temp_total = 0;
    let temp_quantity = 0;
    let temp_return_quantity = 0;

    categoriesAnalyticsData?.categories?.forEach((el) => {
      temp_quantity += el?.total_quantity || 0 + el?.return_items_quantity || 0;
      temp_total += el?.total_amount || 0;
      temp_return_quantity += el?.return_items_quantity || 0;
      if (labels.length < 5) {
        labels.push(el?.name || "N/A");
        dataSet.push(el?.total_amount);
      } else {
        if (labels.length === 5) {
          labels[4] = "Others";
          dataSet[4] = (dataSet[4] || 0) + el?.total_amount || 0;
        } else {
          dataSet[4] += el?.total_amount || 0;
        }
      }
    });

    setTotalData({
      total_amount: Number(temp_total).toFixed(2),
      total_quantity: temp_quantity,
      total_return_quantity: temp_return_quantity,
    });

    setData({
      labels: labels,
      datasets: [
        {
          data: dataSet,
          backgroundColor: colors,
          borderWidth: 0,
        },
      ],
    });
  }, [categoriesAnalyticsData]);
  return (
    <div className="product-analytics">
      <div className="container-wrapper product-sales">
        <p className="heading">Categories Graph</p>

        <div className="product-chart">
          <div className="chart-container">
            {data?.labels?.length < 1 && (
              <p className="no-data">No data present for this period.</p>
            )}
            <p className="chart-title">
              <span>Total:</span> {currency}{totalData.total_amount || "0"}
            </p>
            <BarChart data={data} currency={currency}/>
          </div>
        </div>

        <p className="heading">Revenue Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>Name</p>
            <p>Amount</p>
            <p>Total QTY</p>
            <p>Return QTY</p>
          </div>

          <div className="table-body">
            {categoriesAnalyticsData?.categories?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{el?.name || "N/A"}</p>
                  <p className="price">
                    {currency}
                    {Number(el?.total_amount).toFixed(2) || "0.00"}
                  </p>
                  <p className="sales-font">{el?.total_quantity || 0 + el?.return_items_quantity || 0}</p>
                  <p>{el?.return_items_quantity || 0}</p>
                </div>
              );
            })}

            <div className="row total">
              <p>Total</p>
              <p>
                {currency}
                {totalData.total_amount || "0.00"}
              </p>
              <p>{totalData.total_quantity || 0}</p>
              <p>{totalData.total_return_quantity || 0}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryAnalytics;
